import { InstagramLogo, YoutubeLogo, TiktokLogo, FilmReel, EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";
import { STUDIO_INFO } from "@/data/content";

const SOCIALS = [
  { label: "Instagram", icon: InstagramLogo, href: "#" },
  { label: "YouTube", icon: YoutubeLogo, href: "#" },
  { label: "TikTok", icon: TiktokLogo, href: "#" },
  { label: "Vimeo", icon: FilmReel, href: "#" },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 pt-24 md:pt-32 pb-10"
    >
      <div className="px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#E50914] mb-6">
              // {STUDIO_INFO.name}
            </div>
            <h3 className="font-display uppercase text-white text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.88]">
              Vision. <br />
              Execution. <br />
              <span className="text-[#E50914]">Impact.</span>
            </h3>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
              <ContactBlock
                icon={MapPin}
                label="Studio"
                value={
                  <span>
                    {STUDIO_INFO.address.line1}
                    <br />
                    {STUDIO_INFO.address.line2}
                  </span>
                }
              />
              <ContactBlock
                icon={Phone}
                label="Phone"
                value={
                  <a
                    href={`tel:${STUDIO_INFO.phoneTel}`}
                    data-testid="footer-phone"
                    className="hover:text-[#E50914] transition-colors"
                  >
                    {STUDIO_INFO.phoneDisplay}
                  </a>
                }
              />
              <ContactBlock
                icon={EnvelopeSimple}
                label="Email"
                value={
                  <a
                    href={`mailto:${STUDIO_INFO.emailPrimary}`}
                    data-testid="footer-email"
                    className="hover:text-[#E50914] transition-colors break-all"
                  >
                    {STUDIO_INFO.emailPrimary}
                  </a>
                }
              />
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col justify-between gap-10">
            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
                Follow the studio
              </div>
              <div className="flex flex-wrap gap-3">
                {SOCIALS.map((s) => (
                  <a
                    key={s.label}
                    href={s.href}
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="group w-12 h-12 border border-white/15 hover:border-[#E50914] hover:bg-[#E50914] flex items-center justify-center transition-colors duration-200"
                    aria-label={s.label}
                  >
                    <s.icon size={20} weight="regular" className="text-white" />
                  </a>
                ))}
              </div>
            </div>

            <div>
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
                Navigate
              </div>
              <div className="grid grid-cols-2 gap-2">
                {["Work", "Services", "Studio", "Process", "Contact"].map((item) => (
                  <a
                    key={item}
                    href={`#${item.toLowerCase()}`}
                    data-testid={`footer-nav-${item.toLowerCase()}`}
                    className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 hover:text-[#E50914] transition-colors"
                  >
                    — {item}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">
            © {new Date().getFullYear()} {STUDIO_INFO.name}. All frames reserved.
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-600">
            Built for artists. Shot on purpose.
          </div>
        </div>
      </div>
    </footer>
  );
}

function ContactBlock({ icon: Icon, label, value }) {
  return (
    <div className="border-t border-white/10 pt-4">
      <div className="flex items-center gap-2 mb-2">
        <Icon size={14} weight="light" className="text-[#E50914]" />
        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-500">
          {label}
        </span>
      </div>
      <div className="text-white text-sm leading-relaxed">{value}</div>
    </div>
  );
}
